import { forwardRef } from "react";
import { Button as AntButton } from "antd";
import "./style.scss";
import { BackArrow } from "assets/icons";

const Button = forwardRef(
  (
    {
      onClick,
      wFull,
      isLoading,
      isDisabled,
      href,
      children,
      className,
      size = "md",
      variant = "primary",
      isBack,
      htmlType,
      icon,
      height,
      form,
      ...props
    },
    ref,
  ) => {
    return (
      <AntButton
        ref={ref}
        icon={isBack ? <BackArrow /> : icon || null}
        type={variant}
        onClick={onClick}
        block={wFull}
        loading={isLoading}
        disabled={isDisabled}
        style={{ height: height }}
        form={form}
        href={href}
        htmlType={htmlType}
        className={`${size === "none" ? "transparent" : size === "lg" ? "btn-large" : size === "sm" ? "btn-small" : ""} ${isBack ? "back-btn" : ""} ${className}`}
        {...props}
      >
        {children}
      </AntButton>
    );
  },
);

export default Button;
